import React, { createContext } from 'react';
import {
  useForgotPassword,
  useLogin,
  useLogout,
  useResetPassword,
  useUpdateLoggedInStaff,
} from '../api/staff/staffQueries';
import { useGetStaff } from '../api/staff/staffQueries.js';
import { useGetOrganizationById } from '../api/organization/organizationQueries.js';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { data: user } = useGetStaff();
  const org = useGetOrganizationById(user && user.organizationId);

  const { mutate: login, isPending: loginLoading } = useLogin();
  const { mutate: logout, isPending: isLoggingOut } = useLogout();
  const {
    mutate: forgotPassword,
    isPending: forgotPasswordLoading,
    error: forgotPasswordError,
    isSuccess: forgotPasswordSuccess,
  } = useForgotPassword();
  const {
    mutate: resetPassword,
    isPending: resetPasswordLoading,
    isSuccess: resetPasswordSuccess,
  } = useResetPassword();

  const { mutate: updateProfile, isPending: updateProfileLoading } =
    useUpdateLoggedInStaff();

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        loginLoading,
        logout,
        isLoggingOut,
        org,
        forgotPassword,
        forgotPasswordLoading,
        forgotPasswordError,
        forgotPasswordSuccess,
        resetPassword,
        resetPasswordLoading,
        resetPasswordSuccess,
        updateProfile,
        updateProfileLoading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
